import React, { useEffect } from "react";
import Navbar from "./Navbar";
import TermsofUseText from "./commonTextPages/TermsofUseText";
import WrapperContainer from "./utilities/WrapperContainer";

export default function TermsofUse() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Navbar/>
      <WrapperContainer 
        maxwidth="70%"
        title="Terms Of Use"
        content={<TermsofUseText />}
        loggedin={true}
      />
    </>
  );
}
